var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 160,
    viewBox: "0 0 216 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broken_Pencil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M114.78 141.098C108.288 138.962 101.901 136.476 95.6637 133.662C97.1198 135.478 98.5758 137.293 100.032 139.109C100.032 139.109 93.2784 136.997 93.2566 136.997C90.9598 136.297 88.9276 138.649 89.9827 140.799C92.2957 145.548 94.6543 150.492 96.9902 155.349C98.3029 158.082 94.9072 160.599 92.6647 158.573C70.5907 137.96 62.7105 131.491 50.5509 121.495C42.3709 114.77 35.9039 106.426 28.0417 99.3374C26.0231 97.5174 23.9199 95.7126 22.5158 93.3855C21.1044 91.0461 20.4226 87.9485 21.8932 85.5367C26.4253 78.1045 29.5689 72.9118 38.9392 64.5689C39.745 63.824 39.8999 63.9987 43.7682 63.7801C46.7141 63.6593 46.1636 63.6113 46.7764 63.9246C49.9234 65.459 48.8479 64.884 52.6335 67.919C59.9045 73.8821 67.1151 80.3469 74.3876 86.4625C81.8358 92.707 89.7344 98.2499 97.2469 104.385C97.5103 104.599 111.044 115.662 111.305 115.88C113.062 117.301 112.437 120.118 110.242 120.662C108.307 121.139 107.524 123.435 108.716 124.991C110.867 127.801 117.479 136.385 117.81 136.819C119.442 138.943 117.348 141.926 114.78 141.098Z",
    fill: "#181A49"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M93.9936 136.805C92.7479 136.425 91.5765 136.938 90.9535 137.837C90.4486 137.45 90.0512 136.931 89.5891 136.478C89.5698 136.459 52.7293 105.726 47.3842 101.187C44.3985 98.6536 33.6374 89.3994 31.1576 86.3797C27.052 81.5095 32.0667 76.5688 42.5371 87.0075C78.2393 122.381 88.4304 125.345 93.6122 135.698C93.7899 136.044 93.9463 136.435 93.9936 136.805Z",
    fill: "#35388C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M116.093 141.183C114.5 139.648 77.7909 109.779 61.8101 96.4248C57.9103 93.1644 43.8179 81.1533 40.8811 77.59C35.5084 71.2502 42.2118 65.2175 55.5522 78.3812C84.4921 106.635 105.363 122.803 110.729 127.597L117.814 136.808C119.16 138.56 117.964 140.903 116.093 141.183Z",
    fill: "#35388C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.2187 64.6697C48.2189 64.6914 48.1974 64.7134 48.1758 64.7354C47.8085 65.0441 46.5416 64.7298 46.1063 64.7778C42.8069 65.082 40.4316 68.0355 41.0963 71.4728C41.2348 72.2558 40.6094 72.9157 39.8031 72.9019C34.6633 72.855 30.8932 77.362 31.7044 82.3293C31.7986 83.0256 31.3257 83.6839 30.6075 83.7565C26.8478 84.1209 23.6759 86.9524 23.2496 90.9977C23.2112 91.4011 23.4979 93.1433 23.2732 93.3724C22.9295 93.8551 22.1854 93.5356 21.9408 93.037L6.73842 62.8809L6.73821 62.8591C6.59563 62.5769 1.90629 53.2937 2.2044 53.8839C0.959742 51.4124 3.32909 48.6654 5.95228 49.5327C36.3468 59.5444 46.4491 61.3514 48.2187 64.6697Z",
    fill: "#F2C997"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M48.206 64.8817C38.4927 64.5697 30.8589 70.72 15.1216 66.0397C12.2326 65.1611 9.70581 63.5637 6.74512 62.8547L4.72266 58.8439C9.70475 57.7732 10.3486 53.8031 12.1236 51.5586C27.4601 56.7109 30.8392 56.981 44.0795 61.8304C44.8231 62.1062 46.8752 63.3409 48.206 64.8817Z",
    fill: "#F5D4A7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.74446 62.8672L0.609379 50.6794C-0.0457655 49.3779 1.1997 47.934 2.58325 48.391L17.5561 53.3371C17.4828 54.2537 16.9684 55.1163 16.0196 55.8353C14.9195 56.6651 13.0161 55.9674 11.8476 57.0042C10.2942 58.3724 11.2415 59.6031 10.4121 61.2107C9.81607 62.4593 8.13491 62.4087 6.74446 62.8672Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M91.9302 137.151C72.4635 118.922 52.1348 101.096 31.5107 84.1659C30.9542 83.7106 31.6411 82.8683 32.2003 83.325C52.8436 100.267 73.1917 118.111 92.6756 136.356C93.199 136.849 92.4622 137.641 91.9302 137.151Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M104.935 128.09C94.6912 122.99 86.7706 114.204 78.5464 106.358C72.2461 100.352 65.4574 94.6556 58.8919 89.1482L40.4247 73.6523C39.87 73.1943 40.5755 72.3543 41.1228 72.8198L59.5578 88.2863C66.1705 93.8314 72.9743 99.5407 79.296 105.567C87.4052 113.293 95.3138 122.083 105.419 127.115C105.689 127.249 105.798 127.575 105.665 127.845C105.531 128.117 105.201 128.223 104.935 128.09Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M205.312 40.9052C201.878 45.2513 161.935 93.1103 160.231 95.4958C157.066 99.9346 153.157 106.632 147.045 112.709C145.018 114.755 141.592 118.645 138.7 119.197C137.513 115.941 140.726 110.462 141.654 107.293C142.286 105.13 143.049 103.031 143.616 100.846C143.838 100.062 144.315 94.9924 144.905 94.6022C143.238 95.6864 141.638 96.9006 140.169 98.2224C138.83 99.4123 137.521 101.408 136.004 102.229C135.608 100.205 136.469 98.84 138.548 90.7217C132.743 94.7033 128.186 96.9232 121.84 99.9077L121.819 99.9079C116.379 102.464 115.984 101.434 117.935 97.1795C118.191 96.591 123.321 85.2096 124.778 82.0125C121.501 83.2434 118.134 84.279 114.743 85.0971C114.286 85.2106 113.889 84.6916 114.125 84.2753C119.498 74.6352 128.15 68.318 135.302 60.0765C151.092 41.8316 147.981 45.456 149.691 43.4619C150.389 43.455 152.729 39.9892 153.246 39.3741C163.506 27.5966 155.707 36.744 173.786 16.881C175.042 15.549 175.26 14.6548 176.552 14.5658C176.814 14.54 182.54 13.9742 182.19 14.0088C183.104 13.9343 184.021 14.1431 184.789 14.6584C192.321 19.6655 199.044 25.5649 204.34 32.9404C205.268 34.2168 206.063 35.2547 206.231 36.8653C206.394 38.3128 206.205 39.7672 205.312 40.9052Z",
    fill: "#181A49"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M177.533 30.4585C177.123 32.1368 179.738 28.589 129.215 90.4412C126.739 93.4725 124.332 96.7646 121.836 99.905L121.814 99.9053C114.451 103.365 116.611 100.105 119.913 92.7777C121.271 90.8845 143.874 63.1641 144.084 62.9061C171.941 28.6958 173.732 25.9748 176.457 27.4408C177.465 27.9972 177.806 29.3446 177.533 30.4585Z",
    fill: "#35388C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M191.62 39.2001C191.177 40.8802 194.463 36.4968 144.012 98.3477C144.257 96.7111 144.544 94.8346 144.912 94.5913C143.245 95.6754 141.645 96.8896 140.176 98.2114C138.837 99.4014 137.528 101.397 136.011 102.218C135.781 101.044 136.073 99.6902 136.452 98.3791C136.659 98.1188 176.769 48.3452 186.139 38.0125C187.303 36.7372 189.033 35.3692 190.544 36.1822C191.552 36.7387 191.892 38.0861 191.62 39.2001Z",
    fill: "#35388C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M213.652 33.1822C210.457 37.2377 207.027 40.4226 203.338 43.2852C204.073 42.7114 188.101 29.4486 186.696 28.3295C183.775 26.0054 180.875 23.6158 178.277 20.9181C177.606 20.2312 175.561 17.9913 175.391 17.6567C173.869 15.6701 173.344 15.1667 174.845 13.1956C175.105 12.9305 185.456 0.915341 190.294 0.122008C192.663 -0.333599 194.747 1.25764 196.488 2.91473C203.261 9.25314 208.524 17.0228 213.72 24.7059C216.213 28.394 216.174 30.0751 213.652 33.1822Z",
    fill: "#E94641"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M210.869 36.4614C209.037 38.4404 207.051 40.3122 204.954 42.0324C195.588 34.643 177.787 21.1861 174.613 16.6675C173.686 15.413 173.83 14.6054 174.432 13.7715C187.347 18.0835 200.777 22.9992 209.188 33.8853C209.828 34.7069 210.424 35.5508 210.869 36.4614Z",
    fill: "#DC2E2F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M117.272 100.139C121.137 94.0365 128.882 84.7402 136.369 75.7528C142.133 68.833 168.014 37.0607 174.182 28.9652C174.61 28.3916 175.49 29.0502 175.049 29.6247C158.174 51.7673 124.483 90.7906 118.193 100.721C117.81 101.329 116.886 100.749 117.272 100.139Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M142.488 95.8724C156.251 76.5288 171.283 57.7704 187.168 40.1206C187.662 39.5848 188.455 40.3173 187.979 40.8488C172.122 58.4685 157.113 77.1926 143.375 96.502C142.956 97.0916 142.071 96.4569 142.488 95.8724Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M204.344 44.0526C205.526 46.7093 203.325 49.2116 200.793 48.5543C202.077 50.245 200.972 53.0445 198.809 52.7573C189.845 40.9065 178.352 30.9763 165.339 23.8284C165.267 21.86 166.681 20.7272 168.251 20.9016L168.273 20.9232C168.36 20.9005 168.469 20.9213 168.556 20.9422C168.134 20.0748 168.271 18.5701 168.896 17.845C169.521 17.1197 170.585 16.8041 171.525 17.078C171.171 16.4902 171.247 15.3309 171.633 14.7892C173.566 12.0247 179.644 16.322 181.55 17.4143C185.034 19.3841 188.326 21.7046 191.401 24.2668C200.026 31.5265 210.068 44.9356 204.344 44.0526Z",
    fill: "#CFEFFF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M204.618 46.0804C204.438 47.1292 203.838 47.8706 203.179 48.208C195.995 40.6912 187.689 33.6495 178.658 27.4479C175.784 25.4937 171.538 23.5314 168.266 20.9275C168.353 20.9049 168.462 20.9256 168.549 20.9465C168.126 20.0792 168.264 18.5744 168.889 17.8493C169.513 17.1241 170.578 16.8084 171.517 17.0824C171.296 16.7142 171.247 16.17 171.329 15.668C175.038 18.333 178.467 21.3492 181.917 24.3435C201.752 41.6167 203.379 42.5805 204.618 46.0804Z",
    fill: "#E1F4FF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M88.3162 81.1978C82.6679 74.9761 77.0195 68.7544 71.3711 62.5327C72.3225 60.8286 72.9555 59.4541 73.9069 57.75C79.0908 65.5517 83.1323 73.3961 88.3162 81.1978Z",
    fill: "#E94641"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M96.6113 69.1414C93.3411 58.2854 90.071 47.4293 86.8008 36.5733C89.024 35.2461 90.6495 34.0869 92.8727 32.7598C94.603 45.1216 94.8811 56.7796 96.6113 69.1414Z",
    fill: "#E94641"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M107.09 69.0338C110.39 61.3057 113.69 53.5777 116.99 45.8496C118.936 46.0039 120.449 46.0061 122.395 46.1604C117.465 54.1251 112.02 61.0691 107.09 69.0338Z",
    fill: "#E94641"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M215.18 30.6614C203.652 19.6654 190.667 2.26712 190.234 0.079039C192.604 -0.376568 194.688 1.21467 196.428 2.87176C203.202 9.21017 208.464 16.9799 213.661 24.663C215.016 26.6684 216.043 28.4415 215.18 30.6614Z",
    fill: "#DC2E2F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M17.3799 83.1007C14.9638 77.1969 12.0259 71.4578 8.64855 66.04C8.26913 65.4301 9.18863 64.8555 9.57478 65.4649C12.9824 70.9333 15.9485 76.7296 18.3886 82.6864C18.661 83.3582 17.6528 83.7638 17.3799 83.1007Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M209.767 20.7434C205.08 13.9035 199.406 7.8171 192.908 2.65273C192.341 2.20285 193.027 1.34899 193.585 1.79917C200.169 7.03185 205.915 13.1984 210.667 20.1259C211.071 20.724 210.18 21.3346 209.767 20.7434Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M158.048 88.0032C162.8 81.6919 167.965 75.5681 173.395 69.8012C173.894 69.2773 174.681 70.025 174.19 70.5466C168.785 76.2855 163.647 82.3793 158.918 88.6584C158.49 89.2349 157.613 88.5812 158.048 88.0032Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M18.7215 85.6149L18.7188 85.3425C18.7116 84.6225 19.8009 84.6111 19.8081 85.3317L19.8108 85.604C19.8179 86.324 18.7286 86.3355 18.7215 85.6149Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M9.67283 46.4709L6.89555 41.0536C6.56459 40.4028 7.54274 39.9256 7.8651 40.5546L10.6424 45.9762C10.7791 46.2429 10.6739 46.5716 10.405 46.7083C10.1394 46.8444 9.81147 46.7414 9.67283 46.4709Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M12.2933 46.0474L14.3673 37.8499C14.5428 37.1593 15.6033 37.4157 15.4253 38.1161L13.3513 46.3135C13.1712 47.0092 12.1167 46.7477 12.2933 46.0474Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M16.5301 47.7614L18.6763 44.4719C19.0639 43.8726 19.9836 44.4565 19.5886 45.0671L17.4425 48.3566C17.0513 48.9602 16.1358 48.3657 16.5301 47.7614Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M198.259 63.2011C197.998 61.0441 198.171 58.8019 198.757 56.7194C198.952 56.0297 200 56.3161 199.807 57.0154C199.258 58.9613 199.098 61.0544 199.339 63.0713C199.428 63.7835 198.344 63.9266 198.259 63.2011Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M204.359 61.447L201.339 56.8342C200.945 56.2305 201.856 55.6387 202.252 56.2379L205.273 60.8506C205.437 61.1022 205.366 61.4391 205.114 61.6054C204.854 61.7722 204.521 61.6927 204.359 61.447Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M207.773 55.3883L205.039 54.3261C204.374 54.0696 204.751 53.0578 205.433 53.3094L208.167 54.3716C208.449 54.4816 208.587 54.7973 208.479 55.0771C208.37 55.3501 208.064 55.4976 207.773 55.3883Z",
    fill: "#010101"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-icon.dd3e1d0c4d1bff7a0a8274f435a2278b.svg";
export { ForwardRef as ReactComponent };